import { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../types/iso-date';
import { deconstructDate } from '../helper/deconstruct-date.function';

/**
 * Extracts the month (1-12) from an ISO 8601 date or date-time string.
 *
 * Supported inputs:
 * - Date-only: YYYY-MM-DD
 * - Date-time (no tz): YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?
 * - Date-time with tz: YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?(Z|±HH:MM)
 *
 * Returns the numeric month (1-12).
 * Throws if the input is not a valid ISO date/date-time in one of the above forms.
 */
export function getMonth(input: IsoDate | IsoDateTime | IsoDateTimeTz): number {
  const {month} = deconstructDate(input);
  if(!month)
    throw new Error('getMonth: invalid ISO date/date-time string');
  return month;
}
